import { render } from "./TrainingResourcesView.vue?vue&type=template&id=faba29ac&scoped=true"
import script from "./TrainingResourcesView.vue?vue&type=script&lang=js"
export * from "./TrainingResourcesView.vue?vue&type=script&lang=js"

import "./TrainingResourcesView.vue?vue&type=style&index=0&id=faba29ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faba29ac"]])

export default __exports__